// Optimized: Only load English and Spanish
// Original file with all 40+ languages backed up at index.js.backup
// To restore all languages: cp index.js.backup index.js

import en from './locale/en';
import es from './locale/es';

export default {
  en,
  es,
};
